import Button from '@material-ui/core/Button';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Typography from '@serko/zui/es/Typography';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import compose from 'recompose/compose';
import messages from '../../../../intl/messages';
import { AppState } from '../../../../store/model';
import { isSaviSelectIntl } from '../../../../store/reducers/itinerary/selectors';
import { connect } from 'react-redux';

interface OwnProps {
  className?: string;
  selected?: boolean;
  onSelect?: () => any;
}

interface StateProps {
  isSaviSelectIntl: boolean;
  isAccepted: boolean;
}

interface SelectButtonProps
  extends OwnProps,
    WithStyles<typeof styles>,
    InjectedIntlProps, StateProps {}

const SelectButtonBase: FunctionComponent<SelectButtonProps> = ({
  classes,
  className,
  intl: { formatMessage },
  selected,
  onSelect,
  isSaviSelectIntl,
  isAccepted
}) => {
  return (
    <>
      {selected ? (
        <Typography
          className={classNames(isSaviSelectIntl ? classes.selected : classes.selectedForSaviSelectIntl, className)}
          color='primary'
          lineClamp
          variant="button"
        >
          {formatMessage(messages.common.selected)}
        </Typography>
      ) : (
        <Button
          color="primary"
          onClick={onSelect}
          variant="outlined"
          className={className}
          disabled={isAccepted}
        >
          {formatMessage(messages.common.select)}
        </Button>
      )}
    </>
  );
};

// styled
const styles = (theme: Theme) =>
  createStyles({
    selected: {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
    },
    selectedForSaviSelectIntl: {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      color: theme.zeno.main.primary.main,
    }
  });

const mapStateToProps = (
  state: AppState,
): StateProps => {
  return {
    isSaviSelectIntl: isSaviSelectIntl(state),
    isAccepted: state.itinerary.data.status === 'Accepted',
  };
};

const enhance = compose<SelectButtonProps, OwnProps>(
  connect(mapStateToProps),
  withStyles(styles),
  injectIntl,
);

export const SelectButton = enhance(SelectButtonBase);

SelectButton.displayName = 'SelectButton';
